// src/component/HomePage/BannerDetails/TrendingTodayDetails.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const IMAGE_BASE = "https://online-tech.in/MedicineImage/";

export default function TrendingTodayDetails() {
  const { id } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get(
          `https://online-tech.in/api/Medicine/GetMedicineByCategory?Id=${id}`
        );
        setProducts(res.data || []);
      } catch (err) {
        console.error("API Error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, [id]);

  const handleAddToCart = (product) => {
    console.log("Add to Cart:", product);
    // TODO: integrate with CartContext
  };

  if (loading) return <h4 className="text-center mt-5">Loading...</h4>;
  if (!products.length) return <h4 className="text-center mt-5">No products found</h4>;

  return (
    <div className="px-4 md:px-8 py-6 bg-gray-50 rounded-xl shadow-lg mt-5">
      <h4
        className="text-center text-2xl md:text-3xl font-extrabold mb-6
          bg-gradient-to-r from-red-500 via-pink-500 to-orange-400
          bg-clip-text text-transparent tracking-wide"
      >
        Category {id} Products
      </h4>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {products.map((p) => (
          <div
            key={p.id}
            className="border rounded-lg p-2 shadow-sm hover:shadow-md transition bg-white flex flex-col"
          >
            {/* Image */}
            <div className="h-24 flex items-center justify-center mb-2">
              <img
                src={`${IMAGE_BASE}${p.medicineImage}`}
                alt={p.name}
                className="h-full object-contain"
                onError={(e) => {
                  e.target.src =
                    "https://via.placeholder.com/100?text=No+Image";
                }}
              />
            </div>

            {/* Name */}
            <h4 className="text-sm font-semibold line-clamp-1">{p.name}</h4>

            {/* Salt */}
            <p className="text-xs text-gray-500 line-clamp-1">{p.saltName}</p>

            {/* Strength */}
            <p className="text-xs text-gray-600">{p.strength}</p>

            {/* Description */}
            <p className="text-[11px] text-gray-400 line-clamp-2 mt-1">{p.description}</p>

            {/* Bottom Section */}
            <div className="mt-auto flex items-center justify-between">
              {p.isPrescription && (
                <span className="text-[10px] text-red-600 font-medium">
                  Prescription
                </span>
              )}

              <button
                onClick={() => handleAddToCart(p)}
                className="ml-auto px-2 py-[4px] text-[13px] bg-green-100 text-green-700 border border-green-600 rounded hover:bg-green-200 transition"
              >
                Add
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}